



// import React, { useState, useEffect, useCallback } from 'react';
// import { useLocation, useNavigate, Link } from 'react-router-dom';
// import { collection, getDocs, query, where, addDoc, Timestamp } from 'firebase/firestore';
// import { db } from '../../firebase/firebaseConfig';
// import './ProductsPage.css';
// // Import FirestoreService and helper functions
// import { FirestoreService } from '../../firebase/firestoreService';
// import FloatingActions from '../../components/FloatingActions/FloatingActions';

// const ProductsPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedCategory, setSelectedCategory] = useState('All');
//   const [categories, setCategories] = useState([]);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userId, setUserId] = useState(null);

//   // Check login status
//   useEffect(() => {
//     try {
//       const authToken = localStorage.getItem('authToken');
//       setIsLoggedIn(!!authToken);
      
//       const userData = localStorage.getItem('userData');
//       if (userData) {
//         const parsedData = JSON.parse(userData);
//         setUserId(parsedData?.uid || null);
//       }
//     } catch (error) {
//       console.error("Error checking login status:", error);
//     }
//   }, []);

//   // Function to parse query parameters
//   const getQueryParam = (param) => {
//     const params = new URLSearchParams(location.search);
//     return params.get(param);
//   };

//   // Function to convert URL slug back to a readable category name
//   const formatCategoryName = (slug) => {
//     if (!slug) return '';

//     return slug
//       .replace(/-/g, ' ')
//       .split(' ')
//       .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(' ');
//   };

//   // Set initial selectedCategory based on URL query parameter
//   useEffect(() => {
//     const categoryFromUrl = getQueryParam('category');
//     if (categoryFromUrl) {
//       // Convert the URL slug back to the original category name format
//       const formattedCategory = formatCategoryName(categoryFromUrl);

//       // Find exact category match in our categories array (if available)
//       if (categories.length > 0) {
//         const exactMatch = categories.find(
//           cat => cat.name.toLowerCase() === formattedCategory.toLowerCase()
//         );
//         if (exactMatch) {
//           setSelectedCategory(exactMatch.name);
//         } else {
//           setSelectedCategory(formattedCategory);
//         }
//       } else {
//         setSelectedCategory(formattedCategory);
//       }
//     } else {
//       setSelectedCategory('All');
//     }
//   }, [location, categories]);

//   // Fetch categories and category items from Firestore
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         // Fetch categories - modified to avoid composite index requirement
//         const categoriesQuery = query(
//           collection(db, 'categories'),
//           where('active', '==', true)
//         );
//         const categoriesSnapshot = await getDocs(categoriesQuery);
//         const categoriesData = categoriesSnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         // Sort categories by createdAt client-side
//         categoriesData.sort((a, b) => {
//           // Handle missing createdAt values
//           if (!a.createdAt) return 1;
//           if (!b.createdAt) return -1;
//           // Sort in descending order (newest first)
//           return b.createdAt - a.createdAt;
//         });

//         setCategories(categoriesData);

//         // Fetch category items - modified to avoid composite index requirement
//         const categoryItemsQuery = query(
//           collection(db, 'categoryItems'),
//           where('active', '==', true)
//         );
//         const categoryItemsSnapshot = await getDocs(categoryItemsQuery);
//         const categoryItemsData = categoryItemsSnapshot.docs.map(doc => {
//           const data = doc.data();
//           return {
//             id: doc.id,
//             name: data.name || 'Untitled Item',
//             price: data.price || 0,
//             description: data.description || '',
//             fullDescription: data.fullDescription || '',
//             imageUrl: data.imageUrl || '',
//             category: data.categoryName || 'Uncategorized',
//             material: data.material || '',
//             dimensions: data.dimensions || '',
//             weight: data.weight || '',
//             warranty: data.warranty || '',
//             deliverySpeed: data.deliverySpeed || 'normal',
//             originalDeliverySpeed: data.deliverySpeed || 'normal',
//             isQuick: data.deliverySpeed === 'quick',
//             createdAt: data.createdAt || 0, // Add createdAt for sorting
//           };
//         });

//         // Sort category items by createdAt client-side
//         categoryItemsData.sort((a, b) => {
//           // Handle missing createdAt values
//           if (!a.createdAt) return 1;
//           if (!b.createdAt) return -1;
//           // Sort in descending order (newest first)
//           return b.createdAt - a.createdAt;
//         });

//         setProducts(categoryItemsData);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setError('Failed to load products. Please try again later.');
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   // Function to update URL when category is changed
//   const handleCategoryChange = (categoryName) => {
//     setSelectedCategory(categoryName);

//     // Update URL with the selected category
//     if (categoryName === 'All') {
//       // Remove category parameter if "All" is selected
//       navigate('/products');
//     } else {
//       // Convert category name to slug format for URL
//       const categorySlug = categoryName
//         .toLowerCase()
//         .replace(/\s+/g, '-')
//         .replace(/[^a-z0-9-]/g, '')
//         .replace(/-+/g, '-')
//         .replace(/^-|-$/g, '');

//       navigate(`/products?category=${categorySlug}`);
//     }
//   };

//   // Filter products based on selected category (case-insensitive)
//   const filteredProducts = selectedCategory === 'All'
//     ? products
//     : products.filter(product =>
//       product.category &&
//       product.category.toLowerCase() === selectedCategory.toLowerCase());

//   // Enhanced ProductCard component with integrated delivery speed display AND cart functionality
//   const EnhancedProductCard = ({ product }) => {
//     const [quantity, setQuantity] = useState(1);
//     const [inCart, setInCart] = useState(false);
//     const [imageError, setImageError] = useState(false);
//     const [inWishList, setInWishList] = useState(false);
//     const [isCompared, setIsCompared] = useState(false);
    
//     // Calculate discounted price (10% off)
//     const originalPrice = product.price || 0;
//     const discountPercentage = 10;
//     const discountedPrice = originalPrice * (1 - discountPercentage / 100);

//     // Check if product is in cart and listen for cart updates
//     useEffect(() => {
//       // Initial check for product in cart
//       checkProductInCart();
//       checkProductInWishList();
//       checkProductInCompare();

//       // Set up event listeners
//       const handleCartUpdate = () => {
//         checkProductInCart();
//       };

//       const handleWishlistUpdate = () => {
//         checkProductInWishList();
//       };

//       const handleCompareUpdate = () => {
//         checkProductInCompare();
//       };

//       // Add event listeners
//       window.addEventListener('cartUpdated', handleCartUpdate);
//       window.addEventListener('wishlistUpdated', handleWishlistUpdate);
//       window.addEventListener('compareUpdated', handleCompareUpdate);

//       // Clean up event listeners
//       return () => {
//         window.removeEventListener('cartUpdated', handleCartUpdate);
//         window.removeEventListener('wishlistUpdated', handleWishlistUpdate);
//         window.removeEventListener('compareUpdated', handleCompareUpdate);
//       };
//     }, [product.id]);

//     // Function to check if product is in cart
//     const checkProductInCart = () => {
//       const existingCart = localStorage.getItem('cartItems');
//       if (existingCart) {
//         try {
//           const parsedCart = JSON.parse(existingCart);
//           const cartArray = Array.isArray(parsedCart) ? parsedCart : [];

//           const existingProduct = cartArray.find(item => item.id === product.id);
//           if (existingProduct) {
//             setInCart(true);
//             setQuantity(existingProduct.quantity || 1);
//           } else {
//             setInCart(false);
//             setQuantity(1);
//           }
//         } catch (error) {
//           console.error("Error parsing cart items:", error);
//           setInCart(false);
//           setQuantity(1);
//         }
//       } else {
//         setInCart(false);
//         setQuantity(1);
//       }
//     };

//     // Function to check if product is in wishlist
//     const checkProductInWishList = () => {
//       const existingWishList = localStorage.getItem('wishListItems');
//       if (existingWishList) {
//         try {
//           const parsedWishList = JSON.parse(existingWishList);
//           const wishListArray = Array.isArray(parsedWishList) ? parsedWishList : [];
          
//           const existingProduct = wishListArray.find(item => item.id === product.id);
//           setInWishList(!!existingProduct);
//         } catch (error) {
//           console.error("Error parsing wish list items:", error);
//           setInWishList(false);
//         }
//       } else {
//         setInWishList(false);
//       }
//     };

//     // Function to check if product is in compare list
//     const checkProductInCompare = () => {
//       const existingCompareList = localStorage.getItem('compareItems');
//       if (existingCompareList) {
//         try {
//           const parsedCompareList = JSON.parse(existingCompareList);
//           const compareArray = Array.isArray(parsedCompareList) ? parsedCompareList : [];
          
//           const existingProduct = compareArray.find(item => item.id === product.id);
//           setIsCompared(!!existingProduct);
//         } catch (error) {
//           console.error("Error parsing compare items:", error);
//           setIsCompared(false);
//         }
//       } else {
//         setIsCompared(false);
//       }
//     };

//     // Helper function to dispatch cartUpdated event
//     const dispatchCartUpdate = () => {
//       console.log("Dispatching cart update event");
//       const event = new Event('cartUpdated');
//       window.dispatchEvent(event);
//     };

//     // Helper function to dispatch wishlistUpdated event
//     const dispatchWishlistUpdate = () => {
//       console.log("Dispatching wishlist update event");
//       const event = new Event('wishlistUpdated');
//       window.dispatchEvent(event);
//     };

//     // Helper function to dispatch compareUpdated event
//     const dispatchCompareUpdate = () => {
//       console.log("Dispatching compare update event");
//       const event = new Event('compareUpdated');
//       window.dispatchEvent(event);
//     };

//     // Get current cart from localStorage
//     const getCurrentCart = () => {
//       const existingCart = localStorage.getItem('cartItems');
//       if (existingCart) {
//         try {
//           const parsedCart = JSON.parse(existingCart);
//           return Array.isArray(parsedCart) ? parsedCart : [];
//         } catch (error) {
//           console.error("Error parsing cart items:", error);
//           return [];
//         }
//       }
//       return [];
//     };

//     const handleAddToCart = (e, customQuantity = null) => {
//       e.stopPropagation();
//       const addQuantity = customQuantity || quantity;
//       console.log(`Adding ${product.name} to cart, quantity: ${addQuantity}`);

//       // Get current cart
//       const currentCart = getCurrentCart();

//       // Check if product is already in cart
//       const existingProductIndex = currentCart.findIndex(item => item.id === product.id);

//       // Update cart based on whether product exists
//       let updatedCart;
//       if (existingProductIndex >= 0) {
//         updatedCart = [...currentCart];
//         updatedCart[existingProductIndex].quantity = (updatedCart[existingProductIndex].quantity || 0) + addQuantity;
//       } else {
//         // Format product to match Cart.js expected format
//         const cartItem = {
//           id: product.id,
//           name: product.name,
//           price: discountedPrice, // Use discounted price
//           originalPrice: originalPrice, // Keep original price for reference
//           quantity: addQuantity,
//           imageUrl: product.imageUrl,
//           image: product.imageUrl, // Add both formats for compatibility
//           deliverySpeed: product.deliverySpeed || 'normal',
//           originalDeliverySpeed: product.deliverySpeed || 'normal'
//         };

//         updatedCart = [...currentCart, cartItem];
//       }

//       // Save to localStorage
//       localStorage.setItem('cartItems', JSON.stringify(updatedCart));

//       // Track in Firestore if user is logged in
//       if (isLoggedIn && userId) {
//         FirestoreService.trackCartAdd(product, addQuantity, userId, 'product');
//       }

//       // Update UI state
//       setInCart(true);
//       if (customQuantity) {
//         setQuantity(prev => prev + customQuantity);
//       }

//       // Dispatch cart update event
//       dispatchCartUpdate();
//     };

//     // Add to wishlist function
//     const handleAddToWishList = (e) => {
//       e.stopPropagation();
      
//       // Get existing wishlist
//       const existingWishList = localStorage.getItem('wishListItems');
//       let wishList = [];
      
//       if (existingWishList) {
//         try {
//           wishList = JSON.parse(existingWishList);
//           if (!Array.isArray(wishList)) wishList = [];
//         } catch (error) {
//           console.error("Error parsing wish list:", error);
//         }
//       }
      
//       // Toggle item in wishlist
//       if (!inWishList) {
//         // Add to wishlist
//         wishList.push({
//           id: product.id,
//           name: product.name,
//           price: discountedPrice, // Use discounted price
//           originalPrice: originalPrice, // Keep original price for reference
//           imageUrl: product.imageUrl,
//           image: product.imageUrl,
//           description: product.description || '',
//           fullDescription: product.fullDescription || '',
//           category: product.category || '',
//           material: product.material || '',
//           dimensions: product.dimensions || '',
//           weight: product.weight || '',
//           warranty: product.warranty || '',
//           deliverySpeed: product.deliverySpeed || 'normal'
//         });
//         setInWishList(true);
        
//         // Track in Firestore if user is logged in
//         if (isLoggedIn && userId) {
//           FirestoreService.trackWishlistAdd(product, userId);
//         }
//       } else {
//         // Remove from wishlist
//         wishList = wishList.filter(item => item.id !== product.id);
//         setInWishList(false);
        
//         // Track in Firestore if user is logged in
//         if (isLoggedIn && userId) {
//           FirestoreService.trackWishlistRemove(product.id, userId);
//         }
//       }
      
//       // Save to localStorage
//       localStorage.setItem('wishListItems', JSON.stringify(wishList));
      
//       // Dispatch wishlist update event
//       dispatchWishlistUpdate();
//     };

//     // Add to compare function
//     const handleCompare = (e) => {
//       e.stopPropagation();
      
//       // Get existing compare list
//       const existingCompareList = localStorage.getItem('compareItems');
//       let compareList = [];
      
//       if (existingCompareList) {
//         try {
//           compareList = JSON.parse(existingCompareList);
//           if (!Array.isArray(compareList)) compareList = [];
//         } catch (error) {
//           console.error("Error parsing compare list:", error);
//         }
//       }
      
//       // Toggle item in compare list
//       if (!isCompared) {
//         // Add to compare
//         compareList.push({
//           id: product.id,
//           name: product.name,
//           price: discountedPrice, // Use discounted price
//           originalPrice: originalPrice, // Keep original price for reference
//           imageUrl: product.imageUrl,
//           image: product.imageUrl,
//           description: product.description || '',
//           fullDescription: product.fullDescription || '',
//           category: product.category || '',
//           material: product.material || '',
//           dimensions: product.dimensions || '',
//           weight: product.weight || '',
//           warranty: product.warranty || '',
//           model: product.model || product.id.substring(0, 6),
//           deliverySpeed: product.deliverySpeed || 'normal'
//         });
//         setIsCompared(true);
        
//         // Track in Firestore if user is logged in
//         if (isLoggedIn && userId) {
//           FirestoreService.trackCompareAdd(product, userId);
//         }
//       } else {
//         // Remove from compare
//         compareList = compareList.filter(item => item.id !== product.id);
//         setIsCompared(false);
        
//         // Track in Firestore if user is logged in
//         if (isLoggedIn && userId) {
//           FirestoreService.trackCompareRemove(product.id, userId);
//         }
//       }
      
//       // Save to localStorage
//       localStorage.setItem('compareItems', JSON.stringify(compareList));
      
//       // Dispatch compare update event
//       dispatchCompareUpdate();
//     };

//     const handleViewDetails = (e) => {
//       e.preventDefault();
//       // Navigate to product details page instead of opening modal
//       navigate(`/products/${product.id}`);
//     };

//     const handleImageError = () => {
//       setImageError(true);
//     };

//     const getDeliveryBadge = (deliverySpeed) => {
//       switch (deliverySpeed) {
//         case 'quick':
//           return (
//             <span className="delivery-badge1 quick-delivery">
//               <span className="delivery-icon">⚡</span>
//               Quick
//             </span>
//           );
//         case 'express':
//           return (
//             <span className="delivery-badge1 express-delivery">
//               <span className="delivery-icon">🚀</span>
//               Express
//             </span>
//           );
//         case 'standard':
//           return (
//             <span className="delivery-badge1 standard-delivery">
//               <span className="delivery-icon">📦</span>
//               Standard
//             </span>
//           );
//         case 'late':
//           return (
//             <span className="delivery-badge1 late-delivery">
//               <span className="delivery-icon">🐌</span>
//               Late
//             </span>
//           );
//         case 'normal':
//         default:
//           return (
//             <span className="delivery-badge1 normal-delivery">
//               <span className="delivery-icon">🚚</span>
//               Normal
//             </span>
//           );
//       }
//     };

//     return (
//       <div className="product-card">
//         <div className="product-image-container" onClick={handleViewDetails}>
//           <img
//             src={product.imageUrl || '/placeholder-image.jpg'}
//             alt={product.name}
//             className="product-image"
//             onError={handleImageError}
//           />
//           {/* Delivery badge overlay on image - right side */}
//           <div className="delivery-badge-overlay">
//             {getDeliveryBadge(product.deliverySpeed)}
//           </div>

//           {/* Discount badge overlay - left side */}
//           <div className="discount-badge-overlay">
//             <span className="discount-badge">10%</span>
//           </div>

//           {/* Action buttons that appear on hover */}
//           <div className="product-actions-shop">
//             <button
//               className={`action-btn-shop compare-btn-shop ${isCompared ? 'active' : ''}`}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleCompare(e);
//               }}
//             >
//               <span className="action-icon-shop">⟲</span>
//               <span>Compare</span>
//             </button>

//             <button
//               className="action-btn-shop cart-btn-shop"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleAddToCart(e);
//               }}
//             >
//               <span className="action-icon-shop">🛒</span>
//               <span>Add to Cart</span>
//             </button>

//             <button
//               className={`action-btn-shop wishlist-btn-shop ${inWishList ? 'active' : ''}`}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleAddToWishList(e);
//               }}
//             >
//               <span className="action-icon-shop">♡</span>
//               <span>Wishlist</span>
//             </button>
//           </div>
//         </div>

//         <div className="product-info" onClick={handleViewDetails}>
//           <h3 className="product-name">{product.name}</h3>

//           <div className="product-price-delivery">
//             <div className="product-price">
//               <span className="original-price">₹{originalPrice.toFixed(2)}</span>
//               <span className="discounted-price">₹{discountedPrice.toFixed(2)}</span>
//             </div>
//           </div>

//           <Link 
//             to={`/products/${product.id}`} 
//             className="product-btn view-details-btn"
//             onClick={handleViewDetails}
//           >
//             View Details
//           </Link>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="products-page">
//       <div className="products-page-header">
//         <h1>{selectedCategory === 'All' ? 'Electronic Components' : selectedCategory}</h1>
//         <p style={{ textAlign: 'center', color: 'white' }}>Quality products for your innovation needs</p>
//       </div>

//       <div className="category-navigation">
//         <button
//           className={selectedCategory === 'All' ? 'active' : ''}
//           onClick={() => handleCategoryChange('All')}
//         >
//           All Categories
//         </button>
//         {categories.map((category) => (
//           <button
//             key={category.id}
//             className={selectedCategory === category.name ? 'active' : ''}
//             onClick={() => handleCategoryChange(category.name)}
//           >
//             {category.name}
//           </button>
//         ))}
//       </div>

//       {loading ? (
//         <div className="loading-container">
//           <div className="loading-spinner"></div>
//           <p>Loading products...</p>
//         </div>
//       ) : error ? (
//         <div className="error-container">
//           <div className="error-icon">⚠️</div>
//           <h3>Error</h3>
//           <p>{error}</p>
//         </div>
//       ) : (
//         <div className="products-section">
//           <div className="section-header">
//             <h2>{selectedCategory === 'All' ? 'All Products' : selectedCategory}</h2>
//             <span className="product-count">
//               ({filteredProducts.length} {filteredProducts.length === 1 ? 'product' : 'products'})
//             </span>
//           </div>

//           {filteredProducts.length === 0 ? (
//             <div className="no-products">
//               <div className="no-products-icon">📦</div>
//               <h3>No products found</h3>
//               <p>Try selecting a different category or check back later.</p>
//             </div>
//           ) : (
//             <div className="products-grid">
//               {filteredProducts.map(product => (
//                 <EnhancedProductCard key={product.id} product={product} />
//               ))}
//             </div>
//           )}
//         </div>
//       )}
//       <FloatingActions />
//     </div>
//   );
// };

// export default ProductsPage;






import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { collection, getDocs, query, where, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import './ProductsPage.css';
// Import FirestoreService and helper functions
import { FirestoreService } from '../../firebase/firestoreService';
import FloatingActions from '../../components/FloatingActions/FloatingActions';

const ProductsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [categories, setCategories] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState(null);

  // Check login status
  useEffect(() => {
    try {
      const authToken = localStorage.getItem('authToken');
      setIsLoggedIn(!!authToken);
      
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsedData = JSON.parse(userData);
        setUserId(parsedData?.uid || null);
      }
    } catch (error) {
      console.error("Error checking login status:", error);
    }
  }, []);

  // Function to parse query parameters
  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };

  // Function to convert URL slug back to a readable category name
  const formatCategoryName = (slug) => {
    if (!slug) return '';

    return slug
      .replace(/-/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Set initial selectedCategory based on URL query parameter
  useEffect(() => {
    const categoryFromUrl = getQueryParam('category');
    if (categoryFromUrl) {
      // Convert the URL slug back to the original category name format
      const formattedCategory = formatCategoryName(categoryFromUrl);

      // Find exact category match in our categories array (if available)
      if (categories.length > 0) {
        const exactMatch = categories.find(
          cat => cat.name.toLowerCase() === formattedCategory.toLowerCase()
        );
        if (exactMatch) {
          setSelectedCategory(exactMatch.name);
        } else {
          setSelectedCategory(formattedCategory);
        }
      } else {
        setSelectedCategory(formattedCategory);
      }
    } else {
      setSelectedCategory('All');
    }
  }, [location, categories]);

  // Fetch categories and category items from Firestore
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch categories - modified to avoid composite index requirement
        const categoriesQuery = query(
          collection(db, 'categories'),
          where('active', '==', true)
        );
        const categoriesSnapshot = await getDocs(categoriesQuery);
        const categoriesData = categoriesSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Sort categories by createdAt client-side
        categoriesData.sort((a, b) => {
          // Handle missing createdAt values
          if (!a.createdAt) return 1;
          if (!b.createdAt) return -1;
          // Sort in descending order (newest first)
          return b.createdAt - a.createdAt;
        });

        setCategories(categoriesData);

        // Fetch category items - modified to avoid composite index requirement
        const categoryItemsQuery = query(
          collection(db, 'categoryItems'),
          where('active', '==', true)
        );
        const categoryItemsSnapshot = await getDocs(categoryItemsQuery);
        const categoryItemsData = categoryItemsSnapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            name: data.name || 'Untitled Item',
            price: data.price || 0,
            originalPrice: data.originalPrice || data.price || 0,
            discountPercentage: data.discountPercentage || 0,
            description: data.description || '',
            fullDescription: data.fullDescription || '',
            imageUrl: data.imageUrl || '',
            category: data.categoryName || 'Uncategorized',
            material: data.material || '',
            dimensions: data.dimensions || '',
            weight: data.weight || '',
            warranty: data.warranty || '',
            deliverySpeed: data.deliverySpeed || 'normal',
            originalDeliverySpeed: data.deliverySpeed || 'normal',
            isQuick: data.deliverySpeed === 'quick',
            createdAt: data.createdAt || 0, // Add createdAt for sorting
          };
        });

        // Sort category items by createdAt client-side
        categoryItemsData.sort((a, b) => {
          // Handle missing createdAt values
          if (!a.createdAt) return 1;
          if (!b.createdAt) return -1;
          // Sort in descending order (newest first)
          return b.createdAt - a.createdAt;
        });

        setProducts(categoryItemsData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to load products. Please try again later.');
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Function to update URL when category is changed
  const handleCategoryChange = (categoryName) => {
    setSelectedCategory(categoryName);

    // Update URL with the selected category
    if (categoryName === 'All') {
      // Remove category parameter if "All" is selected
      navigate('/products');
    } else {
      // Convert category name to slug format for URL
      const categorySlug = categoryName
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

      navigate(`/products?category=${categorySlug}`);
    }
  };

  // Filter products based on selected category (case-insensitive)
  const filteredProducts = selectedCategory === 'All'
    ? products
    : products.filter(product =>
      product.category &&
      product.category.toLowerCase() === selectedCategory.toLowerCase());

  // Enhanced ProductCard component with integrated delivery speed display AND cart functionality
  const EnhancedProductCard = ({ product }) => {
    const [quantity, setQuantity] = useState(1);
    const [inCart, setInCart] = useState(false);
    const [imageError, setImageError] = useState(false);
    const [inWishList, setInWishList] = useState(false);
    const [isCompared, setIsCompared] = useState(false);
    
    // Get price information from the product data
    const originalPrice = product.originalPrice || product.price || 0;
    const discountPercentage = product.discountPercentage || 0;
    const sellingPrice = product.price || 0;
    
    // Determine if there's a discount
    const hasDiscount = discountPercentage > 0 && originalPrice > sellingPrice;

    // Check if product is in cart and listen for cart updates
    useEffect(() => {
      // Initial check for product in cart
      checkProductInCart();
      checkProductInWishList();
      checkProductInCompare();

      // Set up event listeners
      const handleCartUpdate = () => {
        checkProductInCart();
      };

      const handleWishlistUpdate = () => {
        checkProductInWishList();
      };

      const handleCompareUpdate = () => {
        checkProductInCompare();
      };

      // Add event listeners
      window.addEventListener('cartUpdated', handleCartUpdate);
      window.addEventListener('wishlistUpdated', handleWishlistUpdate);
      window.addEventListener('compareUpdated', handleCompareUpdate);

      // Clean up event listeners
      return () => {
        window.removeEventListener('cartUpdated', handleCartUpdate);
        window.removeEventListener('wishlistUpdated', handleWishlistUpdate);
        window.removeEventListener('compareUpdated', handleCompareUpdate);
      };
    }, [product.id]);

    // Function to check if product is in cart
    const checkProductInCart = () => {
      const existingCart = localStorage.getItem('cartItems');
      if (existingCart) {
        try {
          const parsedCart = JSON.parse(existingCart);
          const cartArray = Array.isArray(parsedCart) ? parsedCart : [];

          const existingProduct = cartArray.find(item => item.id === product.id);
          if (existingProduct) {
            setInCart(true);
            setQuantity(existingProduct.quantity || 1);
          } else {
            setInCart(false);
            setQuantity(1);
          }
        } catch (error) {
          console.error("Error parsing cart items:", error);
          setInCart(false);
          setQuantity(1);
        }
      } else {
        setInCart(false);
        setQuantity(1);
      }
    };

    // Function to check if product is in wishlist
    const checkProductInWishList = () => {
      const existingWishList = localStorage.getItem('wishListItems');
      if (existingWishList) {
        try {
          const parsedWishList = JSON.parse(existingWishList);
          const wishListArray = Array.isArray(parsedWishList) ? parsedWishList : [];
          
          const existingProduct = wishListArray.find(item => item.id === product.id);
          setInWishList(!!existingProduct);
        } catch (error) {
          console.error("Error parsing wish list items:", error);
          setInWishList(false);
        }
      } else {
        setInWishList(false);
      }
    };

    // Function to check if product is in compare list
    const checkProductInCompare = () => {
      const existingCompareList = localStorage.getItem('compareItems');
      if (existingCompareList) {
        try {
          const parsedCompareList = JSON.parse(existingCompareList);
          const compareArray = Array.isArray(parsedCompareList) ? parsedCompareList : [];
          
          const existingProduct = compareArray.find(item => item.id === product.id);
          setIsCompared(!!existingProduct);
        } catch (error) {
          console.error("Error parsing compare items:", error);
          setIsCompared(false);
        }
      } else {
        setIsCompared(false);
      }
    };

    // Helper function to dispatch cartUpdated event
    const dispatchCartUpdate = () => {
      console.log("Dispatching cart update event");
      const event = new Event('cartUpdated');
      window.dispatchEvent(event);
    };

    // Helper function to dispatch wishlistUpdated event
    const dispatchWishlistUpdate = () => {
      console.log("Dispatching wishlist update event");
      const event = new Event('wishlistUpdated');
      window.dispatchEvent(event);
    };

    // Helper function to dispatch compareUpdated event
    const dispatchCompareUpdate = () => {
      console.log("Dispatching compare update event");
      const event = new Event('compareUpdated');
      window.dispatchEvent(event);
    };

    // Get current cart from localStorage
    const getCurrentCart = () => {
      const existingCart = localStorage.getItem('cartItems');
      if (existingCart) {
        try {
          const parsedCart = JSON.parse(existingCart);
          return Array.isArray(parsedCart) ? parsedCart : [];
        } catch (error) {
          console.error("Error parsing cart items:", error);
          return [];
        }
      }
      return [];
    };

    const handleAddToCart = (e, customQuantity = null) => {
      e.stopPropagation();
      const addQuantity = customQuantity || quantity;
      console.log(`Adding ${product.name} to cart, quantity: ${addQuantity}`);

      // Get current cart
      const currentCart = getCurrentCart();

      // Check if product is already in cart
      const existingProductIndex = currentCart.findIndex(item => item.id === product.id);

      // Update cart based on whether product exists
      let updatedCart;
      if (existingProductIndex >= 0) {
        updatedCart = [...currentCart];
        updatedCart[existingProductIndex].quantity = (updatedCart[existingProductIndex].quantity || 0) + addQuantity;
      } else {
        // Format product to match Cart.js expected format
        const cartItem = {
          id: product.id,
          name: product.name,
          price: sellingPrice, // Use selling price
          originalPrice: originalPrice, // Keep original price for reference
          discountPercentage: discountPercentage, // Store discount percentage
          quantity: addQuantity,
          imageUrl: product.imageUrl,
          image: product.imageUrl, // Add both formats for compatibility
          deliverySpeed: product.deliverySpeed || 'normal',
          originalDeliverySpeed: product.deliverySpeed || 'normal'
        };

        updatedCart = [...currentCart, cartItem];
      }

      // Save to localStorage
      localStorage.setItem('cartItems', JSON.stringify(updatedCart));

      // Track in Firestore if user is logged in
      if (isLoggedIn && userId) {
        FirestoreService.trackCartAdd(product, addQuantity, userId, 'product');
      }

      // Update UI state
      setInCart(true);
      if (customQuantity) {
        setQuantity(prev => prev + customQuantity);
      }

      // Dispatch cart update event
      dispatchCartUpdate();
    };

    // Add to wishlist function
    const handleAddToWishList = (e) => {
      e.stopPropagation();
      
      // Get existing wishlist
      const existingWishList = localStorage.getItem('wishListItems');
      let wishList = [];
      
      if (existingWishList) {
        try {
          wishList = JSON.parse(existingWishList);
          if (!Array.isArray(wishList)) wishList = [];
        } catch (error) {
          console.error("Error parsing wish list:", error);
        }
      }
      
      // Toggle item in wishlist
      if (!inWishList) {
        // Add to wishlist
        wishList.push({
          id: product.id,
          name: product.name,
          price: sellingPrice, // Use selling price
          originalPrice: originalPrice, // Keep original price for reference
          discountPercentage: discountPercentage, // Store discount percentage
          imageUrl: product.imageUrl,
          image: product.imageUrl,
          description: product.description || '',
          fullDescription: product.fullDescription || '',
          category: product.category || '',
          material: product.material || '',
          dimensions: product.dimensions || '',
          weight: product.weight || '',
          warranty: product.warranty || '',
          deliverySpeed: product.deliverySpeed || 'normal'
        });
        setInWishList(true);
        
        // Track in Firestore if user is logged in
        if (isLoggedIn && userId) {
          FirestoreService.trackWishlistAdd(product, userId);
        }
      } else {
        // Remove from wishlist
        wishList = wishList.filter(item => item.id !== product.id);
        setInWishList(false);
        
        // Track in Firestore if user is logged in
        if (isLoggedIn && userId) {
          FirestoreService.trackWishlistRemove(product.id, userId);
        }
      }
      
      // Save to localStorage
      localStorage.setItem('wishListItems', JSON.stringify(wishList));
      
      // Dispatch wishlist update event
      dispatchWishlistUpdate();
    };

    // Add to compare function
    const handleCompare = (e) => {
      e.stopPropagation();
      
      // Get existing compare list
      const existingCompareList = localStorage.getItem('compareItems');
      let compareList = [];
      
      if (existingCompareList) {
        try {
          compareList = JSON.parse(existingCompareList);
          if (!Array.isArray(compareList)) compareList = [];
        } catch (error) {
          console.error("Error parsing compare list:", error);
        }
      }
      
      // Toggle item in compare list
      if (!isCompared) {
        // Add to compare
        compareList.push({
          id: product.id,
          name: product.name,
          price: sellingPrice, // Use selling price
          originalPrice: originalPrice, // Keep original price for reference
          discountPercentage: discountPercentage, // Store discount percentage
          imageUrl: product.imageUrl,
          image: product.imageUrl,
          description: product.description || '',
          fullDescription: product.fullDescription || '',
          category: product.category || '',
          material: product.material || '',
          dimensions: product.dimensions || '',
          weight: product.weight || '',
          warranty: product.warranty || '',
          model: product.model || product.id.substring(0, 6),
          deliverySpeed: product.deliverySpeed || 'normal'
        });
        setIsCompared(true);
        
        // Track in Firestore if user is logged in
        if (isLoggedIn && userId) {
          FirestoreService.trackCompareAdd(product, userId);
        }
      } else {
        // Remove from compare
        compareList = compareList.filter(item => item.id !== product.id);
        setIsCompared(false);
        
        // Track in Firestore if user is logged in
        if (isLoggedIn && userId) {
          FirestoreService.trackCompareRemove(product.id, userId);
        }
      }
      
      // Save to localStorage
      localStorage.setItem('compareItems', JSON.stringify(compareList));
      
      // Dispatch compare update event
      dispatchCompareUpdate();
    };

    const handleViewDetails = (e) => {
      e.preventDefault();
      // Navigate to product details page instead of opening modal
      navigate(`/products/${product.id}`);
    };

    const handleImageError = () => {
      setImageError(true);
    };

    const getDeliveryBadge = (deliverySpeed) => {
      switch (deliverySpeed) {
        case 'quick':
          return (
            <span className="delivery-badge1 quick-delivery">
              {/* <span className="delivery-icon">⚡</span> */}
              Quick
            </span>
          );
        case 'express':
          return (
            <span className="delivery-badge1 express-delivery">
              {/* <span className="delivery-icon">🚀</span> */}
              Express
            </span>
          );
        case 'standard':
          return (
            <span className="delivery-badge1 standard-delivery">
              <span className="delivery-icon">📦</span>
              Standard
            </span>
          );
        case 'late':
          return (
            <span className="delivery-badge1 late-delivery">
              <span className="delivery-icon">🐌</span>
             Eco
            </span>
          );
        case 'normal':
        default:
          return (
            <span className="delivery-badge1 normal-delivery">
              <span className="delivery-icon">🚚</span>
            Standard
            </span>
          );
      }
    };

    return (
      <div className="product-card">
        <div className="product-image-container" onClick={handleViewDetails}>
          <img
            src={product.imageUrl || '/placeholder-image.jpg'}
            alt={product.name}
            className="product-image"
            onError={handleImageError}
          />
          {/* Delivery badge overlay on image - right side */}
          {/* <div className="delivery-badge-overlay">
            {getDeliveryBadge(product.deliverySpeed)}
          </div> */}

          {/* Discount badge overlay - left side - Only show if there's an actual discount */}
          {hasDiscount && (
            <div className="discount-badge-overlay">
              <span className="discount-badge">{discountPercentage}%</span>
            </div>
          )}

          {/* Action buttons that appear on hover */}
          <div className="product-actions-shop">
            <button
              className={`action-btn-shop compare-btn-shop ${isCompared ? 'active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                handleCompare(e);
              }}
            >
              <span className="action-icon-shop">⟲</span>
              <span>Compare</span>
            </button>

            <button
              className={`action-btn-shop cart-btn-shop ${inCart ? 'active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                handleAddToCart(e);
              }}
            >
              <span className="action-icon-shop">🛒</span>
              <span>Add to Cart</span>
            </button>

            <button
              className={`action-btn-shop wishlist-btn-shop ${inWishList ? 'active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                handleAddToWishList(e);
              }}
            >
              <span className="action-icon-shop">♡</span>
              <span>Wishlist</span>
            </button>
          </div>
        </div>

        <div className="product-info" onClick={handleViewDetails}>
          <h3 className="product-name">{product.name}</h3>

          <div className="product-price-delivery">
            <div className="product-price">
              {hasDiscount ? (
                <>
                  <span className="original-price">₹{originalPrice.toFixed(2)}</span>
                  <span className="discounted-price">₹{sellingPrice.toFixed(2)}</span>
                </>
              ) : (
                <span className="regular-price">₹{sellingPrice.toFixed(2)}</span>
              )}
            </div>
          </div>

          <Link 
            to={`/products/${product.id}`} 
            className="product-btn view-details-btn"
            onClick={handleViewDetails}
          >
            View Details
          </Link>
        </div>
      </div>
    );
  };

  return (
    <div className="products-page">
      <div className="products-page-header">
        <h1>{selectedCategory === 'All' ? 'Electronic Components' : selectedCategory}</h1>
        <p style={{ textAlign: 'center', color: 'white' }}>Quality products for your innovation needs</p>
      </div>

      <div className="category-navigation">
        <button
          className={selectedCategory === 'All' ? 'active' : ''}
          onClick={() => handleCategoryChange('All')}
        >
          All Categories
        </button>
        {categories.map((category) => (
          <button
            key={category.id}
            className={selectedCategory === category.name ? 'active' : ''}
            onClick={() => handleCategoryChange(category.name)}
          >
            {category.name}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading products...</p>
        </div>
      ) : error ? (
        <div className="error-container">
          <div className="error-icon">⚠️</div>
          <h3>Error</h3>
          <p>{error}</p>
        </div>
      ) : (
        <div className="products-section">
          <div className="section-header">
            <h2>{selectedCategory === 'All' ? 'All Products' : selectedCategory}</h2>
            <span className="product-count">
              ({filteredProducts.length} {filteredProducts.length === 1 ? 'product' : 'products'})
            </span>
          </div>

          {filteredProducts.length === 0 ? (
            <div className="no-products">
              <div className="no-products-icon">📦</div>
              <h3>No products found</h3>
              <p>Try selecting a different category or check back later.</p>
            </div>
          ) : (
            <div className="products-grid1">
              {filteredProducts.map(product => (
                <EnhancedProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      )}
      <FloatingActions />
    </div>
  );
};

export default ProductsPage;